// extracted by mini-css-extract-plugin
export default {"wishlist":"WishList_wishlist__B2qvk","wishlist__heading":"WishList_wishlist__heading__OgjbU","wishlist__empty":"WishList_wishlist__empty__dTNcE"};